<!--&================== TITLE ALL TASK ==================&-->
<div class="title-components">
  <h1>Tareas pendientes {{libraryName}}</h1>
</div>


<!--&================= CONTENT-TASKS =================&-->

<div class="Container-AllTasks container-global-components">


  <!---================= CONTAINER TABLE ALL TASK =================--->
  <div class="Table-container-Task-Global">

    <p-table #dt [value]="List_All_Task" [(selection)]="SelectedList_All_Task" dataKey="id" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Name','NameUser']">

      <!--&================= SEARCH AND ALL TASK =================&-->
      <ng-template pTemplate="caption">
        <div class="SectionCreateTotal Section-Task">
          <div class="left-CT">
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Task_Filter" type="text"
                (input)="dt.filterGlobal(Task_Filter, 'contains')" placeholder="Buscar tarea" />
            </div>
          </div>
          <div class="right-CT">
            <div class="AllFiles">Total de Tareas: <b>{{List_All_Task.length}}</b> <i
                class="fa-solid fa-list-check"></i>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">

        <tr>

          <ng-container *ngFor="let Header of HeadersTask">

            <ng-container *ngIf="Header.Key_Header==='NAT'">
              <th pSortableColumn="Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAA'">
              <th pSortableColumn="Date_Start" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Start"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Start" display="menu" class="ml-auto"></p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USA'">
              <th pSortableColumn="NameUser" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="NameUser"></p-sortIcon>
                    <p-columnFilter field="F_NameUser" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre de usuario</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DES'">
              <th pSortableColumn="Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

          </ng-container>

          <th class="ContTask">Revisar</th>

        </tr>

      </ng-template>

      <ng-template pTemplate="body" let-List_All_Task>

        <tr>
          <td *ngFor="let Header of HeadersTask" class="{{Is_Expired_Task(List_All_Task)}}">

            <ng-container *ngIf="Header.Key_Header==='NAT'">
              <div style="display: inline-flex; align-items: center; gap: 6px;">
                <button *ngIf="Is_Expired_Task(List_All_Task) === 'Expired'" 
                   type="button"
                   title="Ver detalle"
                   style="background: none; border: none; padding: 0; margin: 0; color: #fc6161; cursor: pointer; font-size: 1.1em; line-height: 1; display: inline-flex; align-items: center;" 
                   (click)="ShowExpiredMessage(List_All_Task, $event)">
                  <i class="fa-solid fa-circle-exclamation"></i>
                </button>
                <span>{{List_All_Task.Name}}</span>
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAA'">
              {{DateTaskCreate(List_All_Task.Date_Start)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USA'">
              {{List_All_Task.NameUser}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DES'">
              <ng-container *ngIf="List_All_Task.Real_ID_UR === 5; else normalTask">
                {{List_All_Task.Comment || 'Se le ha asignado una tarea de corrección para el documento: ' + List_All_Task.Name}}
              </ng-container>
              <ng-template #normalTask>
                Se le ha asignado la tarea de revisión del documento: {{List_All_Task.Name}}
              </ng-template>

            </ng-container>

          </td>
          <td class="CheckTask">
            <ng-container *ngIf="List_All_Task.Real_ID_UR === 5; else normalBtn">
              <!-- Botón especial para el autor (Ir a la librería para actualizar) -->
              <a (click)="UpdateDocument(List_All_Task)"
                 class="Btn-Task Btn-text-task" style="background-color: #e8f5e9; color: #388e3c; cursor: pointer;">
                <span class="text">Actualizar</span>
              </a>
            </ng-container>
            <ng-template #normalBtn>
              <!-- Botón normal para los aprobadores -->
              <a [routerLink]="['/Dashboard/FIN/CheckTaskAss/',List_All_Task.ID]"
                 [queryParams]="{ LibrarySlug: librarySlug, LibraryName: libraryName, BaseRoute: baseRoute }"
                 class="Btn-Task Btn-text-task">
                <span class="text">Ver tarea</span>
              </a>
            </ng-template>
          </td>
        </tr>

      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="List_All_Task.length>0" colspan="8">Sin coincidencias.</td>
        </tr>
        <tr>
          <td class="Not-Task" colspan="20">
            <!-- &================= NOT TASK =================& -->
            <div class="Not-Task" *ngIf="List_All_Task.length===0 && LoadPage">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Not-Task.png" alt="">
              </div>
              <div class="Text-Not-Task">
                ¡{{GetGreeting()}}, {{NameUser()}}, no tienes tareas por revisar!
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </div>


</div>






<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
